import type { StaticSensorReading } from '@/models/types/plc/static-sensor-reading'
import type { SensoreStaticoMongoDTO } from '../../dto/plc/sensore-statico-mongo-dto'

const mapToStaticSensorReading = (dto: SensoreStaticoMongoDTO): StaticSensorReading => {
    return {
        timestamp: dto.ts,
        value: dto.v,
    }
}

const mapToSensoreStaticoDTO = (sensor: StaticSensorReading): SensoreStaticoMongoDTO => {
    return {
        ts: sensor.timestamp,
        v: sensor.value,
    }
}

export { mapToSensoreStaticoDTO, mapToStaticSensorReading }
